import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=2829c8da&scoped=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"
import style0 from "./Project.vue?vue&type=style&index=0&id=2829c8da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829c8da",
  null
  
)

export default component.exports